import React from "react";
import { Box, Text, HStack, VStack, Badge } from "@chakra-ui/react";
import wmIcon from "../images/sensor2.png";
import fireIcon from "../images/fire-alarm-bell-icon.png";
import { useTranslation } from "react-i18next";

export const FireAlarmDevice = ({ device }) => {
    const { t } = useTranslation();

    return (
        <Box mb="40px">
            <Text fontSize="sm" m="2px">
                {device.deviceName}
            </Text>
            <Box minW="200px" borderWidth="1px" borderRadius="lg" overflow="hidden">
                <Box m="5px" display="flex" alignItems="center">
                    <img width={14} height={14} src={wmIcon} />
                    <Text ml="4px" fontSize="lg">
                        {t("text_fire_alarm")}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[4] === "1" ? 'red' : 'green'}>
                        {device.status[4] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[5] === "1" ? 'red' : 'green'}>
                        {device.status[5] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
            </Box>
        </Box>


    );
};
